import { Component, OnInit, ViewChild, ChangeDetectorRef, ElementRef } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material';
import { FilterService } from "../services/filter.service";
import { MatSnackBar } from '@angular/material/snack-bar';
import { LearnerService } from '../services/learner.service';
import { JobService } from '../services/jobs/job.service';
import { CourseService } from '../services/course.service';
import { MaterialService } from "../services/material.service";
import { Router, NavigationExtras, ActivatedRoute } from "@angular/router";
import { distinctUntilChanged, map } from 'rxjs/operators';
import { NavigationService } from '../services/navigation.service';
import * as _ from 'lodash';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { fromEvent } from 'rxjs';
import { LocationStrategy, Location } from '@angular/common';
import { PortfolioService } from '../services/portfolio/portfolio.service';
import { QuizService } from '../services/quiz.service';
import { CourseUnitsService } from '../services/course-units.service';
import { UtilityService } from './../services/utility.service'
import { statusOfAssignment } from '../_models/staticArray'
import { UserRoleService } from '../services/user-role.service'
declare var $: any;


@Component({
  selector: 'app-submission',
  templateUrl: './submission.component.html',
  styleUrls: ['./submission.component.scss']
})

export class SubmissionComponent implements OnInit {
  loadingJobs: Boolean;
  sortType = 'asc'
  tempData: any
  loadingAssignments: Boolean
  loadingLearners: Boolean
  learners: any = [];
  jobs = [];
  courses;
  showSort: Boolean = false
  selectedJob;
  selectedCourse;
  selectedMaterial;
  materials = [];
  title = []
  options = [];
  statusList = [];
  unitNo = []
  assignmentNo = [];
  assignment: any = [];
  unitList = [];
  selectedUnit;
  selectedAssignment;
  displayedColumns: string[] = ['learnerName', 'Assignment', 'Status', 'View'];
  dataSource: MatTableDataSource<any>;
  sort: MatSort;
  model = { optionOne: false, optionTwo: false, optionThree: false }
  formChangesSubscription;
  filteredLearners = [];
  sepArray = [];
  justUnit = [];
  filterAssignment = [];
  unit: any = [];
  finalLearner = [];
  copyLearners;
  firstJob

  selJob;
  selUnit;
  selAss;
  selStatus: any = [];
  paramsCopy;

  copyData: any;

  isLevel2Job: Boolean;
  level2Submissions;
  selectedSession;
  jobId

  public pageSize = 25;
  public pageIndex = 0;
  public totalSize = 0;
  pageEvent: any;
  activeSort: any = "learnerName";
  sortDirection: any = "asc";
  noApiCalls: boolean = false;
  noDataMsg = {
    title: "No Learners!",
    data: "Try changing filters to display learners"
  }

  noJobMsg = {
    title: "No Jobs!",
    data: "You have not yet created any jobs"
  }
  fileType = false
  quizType = false

  queryParamsObj = {}

  assignmentStatus = statusOfAssignment
  initialData: any;
  allLearners: any
  actualList: [];
  isParams: boolean;
  afterFilter: any;
  allData: any;
  allDataCopy = [];
  // filterUnit: []

  private subject: Subject<string> = new Subject();
  searchText: any;
  searchKey: any;
  searchActive: boolean = false;
  portfolio: any;
  allSessions: any = [];
  allSessionsCopy = [];
  courseType: string;
  quizList = []
  selectedQuiz
  selQuiz
  displayType = false
  typeObj = ['File', 'Knowledge Assessment']
  selType


  @ViewChild(MatSort, { static: true }) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }

  // @ViewChild(MatPaginator, { static: true })

  paginator: MatPaginator;


  @ViewChild(MatPaginator, { static: true }) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }

  setDataSourceAttributes() {
    // this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
  @ViewChild('searchInput', { static: true }) searchInput: ElementRef;
  constructor(private change: ChangeDetectorRef, private route: ActivatedRoute, private navService: NavigationService,
    private router: Router, public _materialService: MaterialService, public _courseService: CourseService, public _quizService: QuizService,
    public _learnerService: LearnerService, public _jobService: JobService, public _filter: FilterService, public _snackBar: MatSnackBar,
    private locationStrategy: LocationStrategy, private _location: Location, public _portfolioService: PortfolioService, public unitService: CourseUnitsService, public _utilityService: UtilityService, public _userRoleService: UserRoleService) {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
    this.dataSource = new MatTableDataSource(this.learners);

  }


  applyFilter(filterValue: string) {
    this.afterFilter = null
    this.dataSource.filter = filterValue.trim().toLowerCase();
    console.log("this.allData", this.allData)

    if (this.dataSource.filteredData.length <= 0) {
      this.afterFilter = "No learner with matched search text found!"
    }
  }
  // this.subject.next(filterValue)
  ngOnInit() {
    console.log("DataSource=====>>>>>", this.dataSource.sortData(this.dataSource.filteredData, this.dataSource.sort))

    $(document).ready(function () {
      console.log("ready!");
      $("#assignmentTitle").hover(
        function () {
          console.log(" ON HOVER ")

          this.showSort = true
        }, function () {
          console.log(" ON HOVER OUT")
          this.showSort = false
        }
      );
    })



    this.route.queryParams.subscribe(params => {

      if (params.jobLevel == 'Level2') {
        console.log("params", params, typeof (params))
        this.getJobs();
        this.getSessionList(params.job).then((res) => {
          console.log('RES===============================>', res);
          // this.allSessions = res;
          this.unit = res
          if (params.unit) {
            this.selUnit = params.unit;
            console.log('this.selUnit :::::::::::::', this.selUnit);
            this.filterAssignmentUsingUnitNumber(this.selUnit);
          }
          if (params.assignment) {
            this.selAss = params.assignment;
          } else {
            if ((res[0].assignment && res[0].assignment.length)) {
              this.assignment = res[0].assignment;
            }
          }


        })
        this.isLevel2Job = true;
        this.queryParamsObj['jobLevel'] = 'Level2';
      } else if (params.jobLevel == 'Level3') {
        this.isLevel2Job = false;
        this.queryParamsObj['jobLevel'] = 'Level3';
      }
      if (params.session) {
        this.queryParamsObj['session'] = this.selectedSession;
        this.selectedSession = params.session
      }

      if (params.Pending && params.Pending == 'true') {
        this.queryParamsObj['Pending'] = true;
        this.assignmentStatus.forEach((e2) => {
          if (e2.display == 'Pending') {
            e2.checked = true
          }
        })
      }

      if (params.Completed && params.Completed == 'true') {
        this.queryParamsObj['Completed'] = true;
        this.assignmentStatus.forEach((e2) => {
          if (e2.display == 'Completed') {
            e2.checked = true
          }
        })
      }

      if (params.Submitted && params.Submitted == 'true') {
        this.queryParamsObj['Submitted'] = true;
        this.assignmentStatus.forEach((e2) => {
          if (e2.display == 'Submitted') {
            e2.checked = true
          }
        })
      }

      if (params.ReSubmitted && params.ReSubmitted == 'true') {
        this.queryParamsObj['ReSubmitted'] = true;
        this.assignmentStatus.forEach((e2) => {
          if (e2.display == 'ReSubmitted') {
            e2.checked = true
          }
        })
      }

      if (params.ResubmitRequested && params.ResubmitRequested == 'true') {
        this.queryParamsObj['ResubmitRequested'] = true;
        this.assignmentStatus.forEach((e2) => {
          if (e2.display == 'ResubmitRequested') {
            e2.checked = true
          }
        })
      }

      if (params.Saved && params.Saved == 'true') {
        this.queryParamsObj['Saved'] = true;
        this.assignmentStatus.forEach((e2) => {
          if (e2.display == 'Saved') {
            e2.checked = true
          }
        })
      }



      if (params) {
        console.log("Params inside if=======>>>", params);

        if (params.searchText) {
          console.log('params.searchText===>', params.searchText);
          this.queryParamsObj['searchText'] = params.searchText;
          this.searchKey = params.searchText;
        }

        if (params.pageSize && params.pageIndex) {
          console.log('params.pageSize===>', params.pageSize, params.pageIndex);
          this.queryParamsObj['pageSize'] = params.pageSize;
          this.queryParamsObj['pageIndex'] = params.pageIndex;
          this.pageIndex = Number(params.pageIndex);
          this.pageSize = Number(params.pageSize);
        }

        if (params.activeSort && params.sortDirection) {
          this.queryParamsObj['activeSort'] = params.activeSort;
          this.queryParamsObj['sortDirection'] = params.sortDirection;
          this.activeSort = params.activeSort
          this.sortDirection = params.sortDirection
        }



        this.isParams = true

        this.selJob = params.job;
        this.queryParamsObj['job'] = this.selJob;

        const paramsJobId = params.job || null
        const paramsUnit = params.unit
        const paramsAssignment = params.assignment

        this.paramsCopy = params;


        this.serverFilter(params);
        console.log("data sent is", params);

        if (paramsJobId != 'undefined' && paramsJobId != 'null' && paramsJobId) {
          console.log("call this ifc cond");

          this.getJobs().then((response: any) => {
            console.log("response of job", response);
            let job: any = this.queryParamsObj
            this.selectedJob = response.find((x) => x._id == job.job)
            this.serverFilter(this.queryParamsObj)
            this.getSessionList(paramsJobId).then((res: any) => {
              console.log("level 3 or level2 res list", res);
              this.unit = res


              if (params.unit) {
                this.selUnit = params.unit;
                console.log('this.selUnit :::::::::::::', this.selUnit);
                this.filterAssignmentUsingUnitNumber(this.selUnit);
              }

              if (params.assignment) this.selAss = params.assignment;

              let sortedList = this.unit.filter(
                a => (a.assignment.some(b => b._id == this.selAss))
              )

              console.log("what is sorted liost", sortedList);
              if (sortedList && sortedList.length && sortedList[0].resources && sortedList[0].resources.length) {
                this.quizList = sortedList[0].resources
              } else {
                this.quizList = []
              }

              if (params.quiz && (this.quizList && this.quizList.length)) {

                this.selQuiz = params.quiz
                console.log("when it is assign, this/", this.selQuiz);
              }

            })
          })
        }
        else {
          console.log(" Without params ")
          this.isParams = false
          this.getJobs();
        }
      } else {
        console.log(" ELSE ")
      }
    })
    this.loadingJobs = true;
    this.getJobs();

    fromEvent(this.searchInput.nativeElement, 'keyup').pipe(
      map((event: any) => {
        return event.target.value;
      })
      , debounceTime(1000), distinctUntilChanged()
    ).subscribe((searchTextValue: any) => {
      console.log("searchText", this.searchText, "searchTextValue", searchTextValue)

      if (searchTextValue === '') {
        this.searchActive = false;
        delete this.queryParamsObj['searchText'];
        this.changeQuery();
      } else {
        this.searchActive = true;
        this.queryParamsObj['searchText'] = searchTextValue;
        this.changeQuery();
      }

    });
  }


  public handlePage(e: any) {
    console.log('Hnadle page', e)
    this.pageSize = e.pageSize;
    this.pageIndex = e.pageIndex;
    this.queryParamsObj['pageSize'] = e.pageSize;
    this.queryParamsObj['pageIndex'] = e.pageIndex;
    // this.router.navigate(['.'], { relativeTo: this.route, queryParams: this.queryParamsObj, replaceUrl: true });
    this.changeQuery();

    // this.serverFilter(this.queryParamsObj)
  }

  jobChanged(event, job) {
    console.log("%cJOB CHANGED event details", "color:blue", event, event.value)

    var index = _.findIndex(this.jobs, function (o) { return o._id == event.value })
    if (index > -1) {
      this.selectedJob = this.jobs[index]
      this.jobId = this.jobs[index]._id
      console.log('JOB FOUND', this.jobs[index])
      if (this.jobs[index].course.type == 'Level2') {
        this.isLevel2Job = true;
        this.courseType = 'Level2'
        this.queryParamsObj['jobLevel'] = 'Level2';
        this.getSessionList(this.jobs[index]._id).then((res) => {
          console.log('RES===============================>', res);
          // this.allSessions = res;
          this.unit = res
          if (res[0].assignment && res[0].assignment.length) {
            this.assignment = res[0].assignment;
          }
          // if (res[0].resources && res[0].resources.length) {
          //   this.quizList = res[0].resources
          // }
        })
      } else {
        this.isLevel2Job = false;
        this.courseType = 'Level3'
        this.queryParamsObj['jobLevel'] = 'Level3';
      }
    }
    else {
      console.log("NO JOBS FOUND");
    }

    delete this.queryParamsObj['unit'];
    delete this.queryParamsObj['assignment'];
    delete this.queryParamsObj['quiz'];
    delete this.queryParamsObj['activeSort'];
    delete this.queryParamsObj['sortDirection'];
    delete this.queryParamsObj['session'];

    this.queryParamsObj['job'] = event.value;

    this.selUnit = '';
    this.selAss = '';
    // this.router.navigate(['.'], { relativeTo: this.route, queryParams: this.queryParamsObj, replaceUrl: true });
    this.changeQuery();
  }

  selectedStatus(event, index, status, display) {
    console.log("event", event, "index", index, "status", status);
    if (event == true) {
      this.queryParamsObj[display] = true;
      this.changeQuery();
    }

    else if (event == false) {
      this.queryParamsObj[display] = false;
      this.changeQuery();
      console.log('Event false Called');
    }
  }


  filterUsingStatus(assignment) {
    if (!assignment.length) {
    } else {
      const finalarray = [];
      this.learners.forEach((e1) => assignment.forEach((e2) => {
        if (e1.assignmentStatus == e2) {
          finalarray.push(e1)
        }
      }));
    }
  }


  assignmentNoChanged(event) {
    this.selectedAssignment = event.value;
    // this.quizList = []
    // console.log("this.selectedAssignment", this.selectedAssignment, event)
    this.queryParamsObj['assignment'] = this.selectedAssignment;
    console.log("what is the selected assignment", this.selectedAssignment);
    delete this.queryParamsObj['quiz'];

    console.log("what is the quiz list array", this.quizList);

    this.changeQuery();
  }


  unitNoChanged(event) {
    console.log("what is event ", event);

    this.selectedUnit = event.value;
    this.selectedAssignment = null
    // this.filterAssignmentUsingUnitNumber(this.selectedUnit);
    this.queryParamsObj['unit'] = this.selectedUnit;
    delete this.queryParamsObj['assignment'];
    delete this.queryParamsObj['quiz'];
    this.changeQuery();
  }

  quizChanged(event) {
    this.selectedQuiz = event.value
    this.queryParamsObj['quiz'] = this.selectedQuiz;
    this.changeQuery()
  }


  sessionChanged(event) {
    this.selectedSession = event.value;
    this.queryParamsObj['session'] = this.selectedSession;
    this.changeQuery();
  }

  filterAssignmentUsingUnitNumber(unitNo) {
    console.log('Unit No::::', unitNo);
    this.assignment = []
    this.quizList = []
    console.log(' this.unit', this.unit);
    this.unit.forEach((e1) => {
      if (e1._id == unitNo) {
        console.log("what is e1", e1);

        // if (e1.resources && !e1.resources.length) {
        this.assignment = e1.assignment;
        // } else {
        //   this.quizList = e1.resources
        // }
      }
    })
    console.log("this.selectedAssignment", this.selectedAssignment);


    let sortedList = this.unit.filter(
      a => (a.assignment.some(b => b._id == this.selectedAssignment))
    )

    console.log("what is sorted liost", sortedList);
    if (sortedList && sortedList.length && sortedList[0].resources && sortedList[0].resources.length) {
      this.quizList = sortedList[0].resources
    } else {
      this.quizList = []
    }

    console.log(' this.assignment======>', this.assignment);
  }


  getRandomColorClass(i) {
    return this._utilityService.getCommonRandomColorClass(i)
  }

  goToInstructorsSubmission(learner) {
    let NavigationExtras: NavigationExtras = {
      state: {
        learner: learner,
        title: this.selectedMaterial.title,
        unitNo: this.unitNo,
        assignmentNo: this.assignmentNo
      }
    };
    this.router.navigateByUrl('/submission/user/learner._id', NavigationExtras)
  }
  someMethod(event) {
    console.log("mat sort event:", event);
    this.activeSort = event.active;
    this.sortDirection = event.direction;
    this.queryParamsObj['activeSort'] = event.active;
    this.queryParamsObj['sortDirection'] = event.direction;
    this.serverFilter(this.queryParamsObj)
  }

  // API CALLS
  getJobs() {
    return new Promise((resolve, reject) => {


      this._jobService.getJobs().subscribe((data) => {
        this.jobs = data.finalJobArray ? data.finalJobArray : data;
        console.log('data in getJobs in submissoion page', this.jobs);
        if (this.jobs && this.jobs.length != 0) {
          this.jobs = this.jobs.filter(singleJob => {
            if (singleJob.course)
              return singleJob
          })
        }

        console.log("this.jobs =====>", this.jobs)
        if (this.jobs && this.jobs.length != 0) {

          console.log('Inside First If');
          let event = {
            value: this.jobs[0]._id
          }
        }
        if (this.isParams == false && this.jobs && this.jobs.length != 0) {
          let event = {
            value: this.jobs[0]._id
          }
          console.log("this.isParams getJobs()", event);
          this.selectedJob = this.jobs[0]
          this.jobChanged(event, this.jobs[0])
        }
        this.loadingJobs = false;
        console.log("JOBS ARE", this.jobs)
        resolve(this.jobs)
      });
    })
  }


  // UTILITY UPDATE DATA
  updateData(learner) {
    console.log("learner details with status", learner);

    this.tempData = JSON.parse(JSON.stringify(learner))
    console.log("UPDATING DATA = ", learner)
    this.dataSource = new MatTableDataSource(learner);
    // this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    console.log("SETTING SORT TO = ", this.dataSource.sort)
    console.log("SETTING paginator TO = ", this.dataSource.paginator)
  }

  getAssignmentList(jobId) {
    return new Promise((resolve, reject) => {
      this._materialService.getMaterialUsingJobIdWithNoGroup(jobId).subscribe((data) => {
        console.log("value of data");

        // this.unit = data;
        resolve(data)
        console.log("getting assignment list", this.unit);
        if (data) {
          this.assignment = data[0].assignment;
        }
      });
    })
  }

  getAllAllotedAssignmentsUsingJobId(jobId) {
    return new Promise((resolve, reject) => {
      this._materialService.allAllotedAssignmentUsingJobId(jobId).subscribe((data) => {

        console.log('data:::', data)
        if (data.length) {
          console.log('Inside IF');
          this.learners = data;
          this.copyLearners = this.learners;
          this.loadingAssignments = false;
          return resolve(this.copyLearners);
        } else {
          console.log('Inside Else');
          this.copyLearners = null;
          return resolve(this.copyLearners);
        }
      });
    })

  }

  getAllotmentListUsingAssignmentId(assignmentId) {
    this._learnerService.getAllotmentListUsingAssignmentId(assignmentId).subscribe((data) => {
      this.learners = data;
      console.log('this.learners===>>', this.learners);
      this.loadingLearners = false;
    });
  }



  // Change query
  changeQuery() {
    console.log('this.queryParamsObj=============>', this.queryParamsObj);

    let queryObj = JSON.parse(JSON.stringify(this.queryParamsObj));

    if (queryObj.job) {
      this.selJob = queryObj.job
      this.getSessionList(queryObj.job).then((ass) => {
        console.log("assingment list", ass);
        this.unit = ass;
        // this.unit = res
        if (ass[0].assignment && ass[0].assignment.length && !queryObj.assignment) {
          console.log("call this first if");

          this.assignment = ass[0].assignment;
        }
        // if (ass[0].resources && ass[0].resources.length) {
        //   this.quizList = ass[0].resources
        // }
        console.log("final unit no displaay data", this.unit);
        if (queryObj.unit) {
          this.selUnit = queryObj.unit;
          console.log('this.selUnit :::::::::::::', this.selUnit);
          this.filterAssignmentUsingUnitNumber(this.selUnit);
        }
        if (queryObj.assignment) {
          this.selAss = queryObj.assignment;
        }



      })
    }



    // this.router.navigate(['.'], { relativeTo: this.route, queryParams: this.queryParamsObj });

    this._location.replaceState(
      this.router.createUrlTree(
        [this.locationStrategy.path().split('?')[0]], // Get uri
        {
          relativeTo: this.route, queryParams: this.queryParamsObj
        }
      ).toString()
    );

    this.serverFilter(this.queryParamsObj);
  }

  sortAssignMent(type) {
    console.log("Yash Shukla", type)
    if (type == 'asc') {
      this.sortType = 'desc'
      console.log("this.dataSource", this.tempData)
      let datalearners = _.sortBy(this.tempData, ['assignmentUnit', 'assignmentNo'], ['asc', 'asc']);
      this.updateData(datalearners)
    } else {
      this.sortType = 'asc'
      let datalearners2 = _.sortBy(this.tempData, ['assignmentUnit', 'assignmentNo']).reverse();
      this.updateData(datalearners2)
    }
  }

  goToSingleAllotment(learner) {
    console.log("LEARNER ON CLICK", this.selectedJob);
    let param = learner.allotemntId ? learner.allotemntId : learner.sessionId
    if (learner.sessionType) {
      var portfolioQparam = {
        courseType: 'Level2',
        sessionType: learner.sessionType,
        learnerId: learner.learnerId
      }

      var navUrl = portfolioQparam
    }
    else {
      navUrl = null
    }

    let NavigationExtras: NavigationExtras = {
      state: {
        learner: learner,
      },
      queryParams: navUrl

    };
    console.log("%cNAVIGATING TO", "color:blue", navUrl);
    let userRole = this.getUserRole()
    let jobId
    if (this.jobId == undefined) {
      this.route.queryParams.subscribe((param) => {
        console.log("what is the current  params data", param);
        jobId = param.job
      })
    } else {
      jobId = this.jobId
    }

    if (learner && learner.quizId) {
      this.router.navigate(['/quiz/appear-quiz'], { queryParams: { quizId: learner.quizId, learnerId: learner.learnerId, jobId: jobId, userRole: userRole } })
    } else {
      console.log("this is for level-3 ", navUrl, userRole);

      this.router.navigate(['/learner/allotment/' + param], { queryParams: { userRole: userRole } })
    }
  }


  getUserRole() {
    let getRole = this._userRoleService.getUserRole(this.selectedJob.instructors, 'job');
    console.log("getRole ?? ", getRole);
    if (getRole.isAdmin) return 0
    else if (getRole.isLearner) return 3
    else if (getRole.isClient) return 4
    else if (getRole.isTrainer) return 1
    else if (getRole.isIQA) return 2
  }

  getStatusColor(status) {
    // console.log("what is status", status);

    if (status || status != undefined) {
      switch (status) {
        case 'Submitted':
          // this.tooltip = 'Submitted';
          return 'Submitted'
          break;

        case 'Completed':
          // this.tooltip = 'Completed';
          return 'Completed'
          break;

        case 'Requested for Resubmission':
          // this.tooltip = 'Request for Resubmission';
          return 'Requested'
          break;

        case 'Re-Submitted':
          // this.tooltip = 'Re-Submitted';
          return 'Re-submitted'
          break;

        case 'Saved':
          // this.tooltip = 'Saved';
          return 'saved'
          break;

        default:
          // this.tooltip = 'Pending';
          return 'Pending'
          break;
      }
    } else {
      // console.log("call this else part", ' ');

      // this.tooltip = 'Pending';
      return 'Pending'
    }
  }


  typeChanged(event) {
    console.log("when type is changed", event);





    console.log("what is in the params", this.queryParamsObj);
    let temp: any = this.queryParamsObj
    let queryObj = {
      job: temp.job,
      jobLevel: temp.jobLevel

    }
    if (event && event.value == 'File') {
      this.loadingAssignments = true
      return this._materialService.filterAllotedAssignment(queryObj).subscribe((data) => {
        console.log("data of final list to display", data);
        this.selType = 'File'
        this.allData = data.items;
        this.allDataCopy = this.allData;
        this.updateData(data.items);
        this.displayedColumns = ['learnerName', 'Assignment', 'Status', 'View'];
        this.loadingAssignments = false;

        if (data && data.metadata && data.metadata[0] && data.metadata[0].total) {
          this.totalSize = data.metadata[0].total;
        }

        this.queryParamsObj['jobLevel'] = temp.jobLevel;
        this.queryParamsObj['job'] = temp.job;
        delete this.queryParamsObj['unit'];
        delete this.queryParamsObj['assignment'];
        delete this.queryParamsObj['quiz'];
        delete this.queryParamsObj['activeSort'];
        delete this.queryParamsObj['sortDirection'];
        delete this.queryParamsObj['session'];



        this._location.replaceState(
          this.router.createUrlTree(
            [this.locationStrategy.path().split('?')[0]], // Get uri
            {
              relativeTo: this.route, queryParams: this.queryParamsObj
            }
          ).toString()
        );
        this.selUnit = '';
        this.selAss = '';
      });
    } else {
      this._quizService.portfolioSubmission(queryObj).subscribe((data) => {
        console.log('data==========>', data)
        this.allData = data.items;
        this.allDataCopy = this.allData;
        this.loadingAssignments = false;
        this.updateData(data.items);
        this.selType = 'Knowledge Assessment'
        this.displayedColumns = ['learnerName', 'quizName', 'status', 'sessionView'];

        if (data && data.metadata && data.metadata[0] && data.metadata[0].total) {
          this.totalSize = data.metadata[0].total;
        }


        this.queryParamsObj['jobLevel'] = temp.jobLevel;
        this.queryParamsObj['job'] = temp.job;
        delete this.queryParamsObj['unit'];
        delete this.queryParamsObj['assignment'];
        delete this.queryParamsObj['quiz'];
        delete this.queryParamsObj['activeSort'];
        delete this.queryParamsObj['sortDirection'];
        delete this.queryParamsObj['session'];



        this._location.replaceState(
          this.router.createUrlTree(
            [this.locationStrategy.path().split('?')[0]], // Get uri
            {
              relativeTo: this.route, queryParams: this.queryParamsObj
            }
          ).toString()
        );
        this.selUnit = '';
        this.selAss = '';

      });
    }


    // })

  }

  serverFilter(paramsData) {

    // if (this.searchActive) {
    //   this.loadingAssignments = false;
    // } else {
    this.loadingAssignments = true;
    // }
    console.log("this is the selected job data", this.selectedJob);
    console.log("what is the level2 job cond", this.isLevel2Job);

    let queryObj = JSON.parse(JSON.stringify(paramsData));
    console.log('Final Query Object ', queryObj);

    console.log("what is the sel type when it is not selected", this.selType);


    if (this.isLevel2Job == true) {


      let typeLength = this.selectedJob && this.selectedJob.course.courseMetaId.trackerType.length
      console.log("total type", typeLength);

      if (typeLength == 2 && typeLength != undefined) {
        this.displayType = true
        if (this.selType == undefined || this.selType == 'Knowledge Assessment') {


          this._quizService.portfolioSubmission(queryObj).subscribe((data) => {
            console.log('data==========>', data)
            this.selType = 'Knowledge Assessment'
            console.log("seleceted type of job", this.selType);
            this.change.detectChanges()
            this.allData = data.items;
            this.allDataCopy = this.allData;
            this.loadingAssignments = false;
            this.updateData(data.items);
            // this.quizType = true
            // this.fileType = false
            // this.updateData(data)
            this.displayedColumns = ['learnerName', 'quizName', 'status', 'sessionView'];

            if (data && data.metadata && data.metadata[0] && data.metadata[0].total) {
              this.totalSize = data.metadata[0].total;
            }

          });

        } else {
          return this._materialService.filterAllotedAssignment(queryObj).subscribe((data) => {
            console.log("data of final list to display", data);
            this.selType = 'File'
            this.allData = data.items;
            this.allDataCopy = this.allData;
            this.updateData(data.items);
            this.fileType = true
            this.quizType = false
            // if (this.isLevel2Job) {
            //   this.displayedColumns = ['learnerName', 'quizName', 'status', 'sessionView'];
            // } else {
            this.displayedColumns = ['learnerName', 'Assignment', 'Status', 'View'];
            // }


            this.loadingAssignments = false;

            if (data && data.metadata && data.metadata[0] && data.metadata[0].total) {
              this.totalSize = data.metadata[0].total;
            }
          });
        }
        console.log("what is the length of type", typeLength);




      } else {
        this.displayType = false
        if (this.selectedJob && this.selectedJob.course.courseMetaId.trackerType && this.selectedJob.course.courseMetaId.trackerType.includes('quiz')) {
          this._quizService.portfolioSubmission(queryObj).subscribe((data) => {
            console.log('data==========>', data)
            this.allData = data.items;
            this.allDataCopy = this.allData;
            this.loadingAssignments = false;
            this.updateData(data.items);
            this.quizType = true
            this.fileType = false
            // this.updateData(data)
            this.displayedColumns = ['learnerName', 'quizName', 'status', 'sessionView'];

            if (data && data.metadata && data.metadata[0] && data.metadata[0].total) {
              this.totalSize = data.metadata[0].total;
            }

          });
        } else {
          return this._materialService.filterAllotedAssignment(queryObj).subscribe((data) => {
            console.log("data of final list to display", data);

            this.allData = data.items;
            this.allDataCopy = this.allData;
            this.updateData(data.items);
            this.fileType = true
            this.quizType = false
            // if (this.isLevel2Job) {
            //   this.displayedColumns = ['learnerName', 'quizName', 'status', 'sessionView'];
            // } else {
            this.displayedColumns = ['learnerName', 'Assignment', 'Status', 'View'];
            // }


            this.loadingAssignments = false;

            if (data && data.metadata && data.metadata[0] && data.metadata[0].total) {
              this.totalSize = data.metadata[0].total;
            }
          });
        }
      }
      console.log('Inside If Part=======>', queryObj)
      this.loadingAssignments = false;
    } else {

      console.log('Inside Else Part=====>', queryObj);
      let typeLength = this.selectedJob && this.selectedJob.course.courseMetaId.trackerType.length
      console.log("total type", typeLength);

      if (typeLength == 2 && typeLength != undefined) {
        this.displayType = true
        if (this.selType == undefined || this.selType == 'Knowledge Assessment') {


          this._quizService.portfolioSubmission(queryObj).subscribe((data) => {
            console.log('data==========>', data)
            this.selType = 'Knowledge Assessment'
            console.log("seleceted type of job", this.selType);
            this.change.detectChanges()
            this.allData = data.items;
            this.allDataCopy = this.allData;
            this.loadingAssignments = false;
            this.updateData(data.items);
            // this.quizType = true
            // this.fileType = false
            // this.updateData(data)
            this.displayedColumns = ['learnerName', 'quizName', 'status', 'sessionView'];

            if (data && data.metadata && data.metadata[0] && data.metadata[0].total) {
              this.totalSize = data.metadata[0].total;
            }

          });

        } else {
          return this._materialService.filterAllotedAssignment(queryObj).subscribe((data) => {
            console.log("data of final list to display", data);
            this.selType = 'File'
            this.allData = data.items;
            this.allDataCopy = this.allData;
            this.updateData(data.items);
            this.fileType = true
            this.quizType = false
            // if (this.isLevel2Job) {
            //   this.displayedColumns = ['learnerName', 'quizName', 'status', 'sessionView'];
            // } else {
            this.displayedColumns = ['learnerName', 'Assignment', 'Status', 'View'];
            // }


            this.loadingAssignments = false;

            if (data && data.metadata && data.metadata[0] && data.metadata[0].total) {
              this.totalSize = data.metadata[0].total;
            }
          });
        }
        console.log("what is the length of type", typeLength);




      } else {
        this.displayType = false
        if (this.selectedJob && this.selectedJob.course.courseMetaId.trackerType && this.selectedJob.course.courseMetaId.trackerType.includes('quiz')) {
          this._quizService.portfolioSubmission(queryObj).subscribe((data) => {
            console.log('data==========>', data)
            this.selType = 'Knowledge Assessment'
            this.allData = data.items;
            this.allDataCopy = this.allData;
            this.loadingAssignments = false;
            this.updateData(data.items);
            this.quizType = true
            this.fileType = false
            // this.updateData(data)
            this.displayedColumns = ['learnerName', 'quizName', 'status', 'sessionView'];

            if (data && data.metadata && data.metadata[0] && data.metadata[0].total) {
              this.totalSize = data.metadata[0].total;
            }

          });
        } else {
          return this._materialService.filterAllotedAssignment(queryObj).subscribe((data) => {
            console.log("data of final list to display", data);
            this.selType = 'File'
            this.allData = data.items;
            this.allDataCopy = this.allData;
            this.updateData(data.items);
            this.fileType = true
            this.quizType = false
            // if (this.isLevel2Job) {
            //   this.displayedColumns = ['learnerName', 'quizName', 'status', 'sessionView'];
            // } else {
            this.displayedColumns = ['learnerName', 'Assignment', 'Status', 'View'];
            // }


            this.loadingAssignments = false;

            if (data && data.metadata && data.metadata[0] && data.metadata[0].total) {
              this.totalSize = data.metadata[0].total;
            }
          });
        }
      }
      console.log('Inside If Part=======>', queryObj)
      this.loadingAssignments = false;



    }
  }


  submissionRedirection(portfolio) {
    console.log('portfolio', portfolio);

    let userRole = this.getUserRole()

    let jobId
    if (this.jobId == undefined) {
      this.route.queryParams.subscribe((param) => {
        console.log("what is the current  params data", param);
        jobId = param.job
      })
    } else {
      jobId = this.jobId
    }

    this.router.navigate(['/appear-quiz'], { queryParams: { quizId: portfolio.quizId, learnerId: portfolio.learnerId, jobId: jobId, userRole: userRole } })
    // this.router.navigate(['/learnerAllotment/' + portfolio.sessionId], { queryParams: { courseType: 'Level2', sessionType: portfolio.sessionType, learnerId: portfolio.learnerId } })
  }

  getSessionList(jobId) {
    console.log("single jobid", this.jobs);

    return new Promise((resolve, reject) => {
      let allSessions = []
      let index = this.jobs.filter(function (o) { return o._id == jobId })
      console.log("what is the all jobs details when it is call", index);
      if (index && index.length) {
        let courseId = index[0].course._id
        this.unitService.getFolderWithMaterial(courseId).subscribe(res => {
          console.log("response of all status in main list file", res);
          this.assignment = []
          this.quizList = []
          this.unit = []
          resolve(res)
        })
      }
    })
  }
}
